export default "__VITE_ASSET__C4iX6bYk__"